
import { GAME_CONFIG } from './gameConfig';

// Initialize the game board as a 2D array
export function initializeBoard() {
  const board = [];
  for (let y = 0; y < GAME_CONFIG.boardHeight; y++) {
    board[y] = [];
    for (let x = 0; x < GAME_CONFIG.boardWidth; x++) {
      board[y][x] = 0; // 0 means empty
    }
  }
  return board;
}

// Get a random block type
export function getRandomBlock() {
  const types = Object.keys(GAME_CONFIG.shapes);
  return types[Math.floor(Math.random() * types.length)];
}

// Create a new block at the top of the board
export function createBlock(scene) {
  const type = getRandomBlock();
  const shape = GAME_CONFIG.shapes[type];
  const color = GAME_CONFIG.colors[type];
  
  // Create a new block object
  const block = {
    type,
    shape,
    color,
    x: Math.floor(GAME_CONFIG.boardWidth / 2) - 2, // Start in the middle top
    y: 0,
    blocks: [] // Will store the Phaser graphics objects
  };
  
  return block;
}

// Check if the block can move to the specified position
export function canMoveTo(board, block, offsetX, offsetY) {
  const shape = block.shape;
  
  for (let y = 0; y < 4; y++) {
    for (let x = 0; x < 4; x++) {
      // Only check filled blocks
      if (shape[y][x] === 1) {
        const boardX = block.x + x + offsetX;
        const boardY = block.y + y + offsetY;
        
        // Check boundaries
        if (boardX < 0 || boardX >= GAME_CONFIG.boardWidth || 
            boardY >= GAME_CONFIG.boardHeight) {
          return false;
        }
        
        // Check if the space is occupied (and not below top of board)
        if (boardY >= 0 && board[boardY][boardX] !== 0) {
          return false;
        }
      }
    }
  }
  
  return true;
}

// Rotate the current block (clockwise)
export function rotateBlock(board, block) {
  // Create a new 4x4 matrix for the rotated shape
  const rotated = [];
  for (let y = 0; y < 4; y++) {
    rotated[y] = [];
    for (let x = 0; x < 4; x++) {
      rotated[y][x] = block.shape[3 - x][y]; // Rotate 90 degrees clockwise
    }
  }
  
  // Check if the rotated position is valid
  const originalShape = block.shape;
  block.shape = rotated;
  
  if (canMoveTo(board, block, 0, 0)) {
    return true; // Rotation successful
  } else {
    // Revert rotation if it's not valid
    block.shape = originalShape;
    return false;
  }
}

// Lock the current block in place on the board
export function lockBlock(scene, board, block) {
  const shape = block.shape;
  
  for (let y = 0; y < 4; y++) {
    for (let x = 0; x < 4; x++) {
      if (shape[y][x] === 1) {
        const boardX = block.x + x;
        const boardY = block.y + y;
        
        // Make sure we don't go out of bounds
        if (boardY >= 0 && boardY < GAME_CONFIG.boardHeight && 
            boardX >= 0 && boardX < GAME_CONFIG.boardWidth) {
          board[boardY][boardX] = block.color;
        }
      }
    }
  }
  
  return board;
}

// Check for and clear completed lines
export function clearLines(scene, board) {
  let linesCleared = 0;
  
  for (let y = GAME_CONFIG.boardHeight - 1; y >= 0; y--) {
    let lineComplete = true;
    
    // Check if this line is complete
    for (let x = 0; x < GAME_CONFIG.boardWidth; x++) {
      if (board[y][x] === 0) {
        lineComplete = false;
        break;
      }
    }
    
    if (lineComplete) {
      linesCleared++;
      
      // Move all lines above down
      for (let moveY = y; moveY > 0; moveY--) {
        for (let x = 0; x < GAME_CONFIG.boardWidth; x++) {
          board[moveY][x] = board[moveY - 1][x];
        }
      }
      
      // Clear the top line
      for (let x = 0; x < GAME_CONFIG.boardWidth; x++) {
        board[0][x] = 0;
      }
      
      // Since we moved all lines down, we need to check this line again
      y++;
    }
  }
  
  return { board, linesCleared };
}

// Check for game over condition
export function isGameOver(board) {
  // If any blocks in the top row are filled, game over
  for (let x = 0; x < GAME_CONFIG.boardWidth; x++) {
    if (board[0][x] !== 0) {
      return true;
    }
  }
  
  return false;
}
